import React from 'react';
import UnifiedTenantManagement from './UnifiedTenantManagement';

export default function TenantSetupTab({ token }) {
  return <UnifiedTenantManagement />;
}
